import type { Query } from '@tanstack/react-query';

import type { LocationFishGroupsController_timelineQueryParams } from '@/services/types';

import type { SiteTimelineScope } from './siteTimeline.types';

/** The scope values the endpoint accepts: a cycle id or `unassigned`. */
const RESOLVED_SCOPE = /^([1-9]\d*|unassigned)$/;

/**
 * The timeline request for a scope. Before the board has resolved one there is nothing to
 * ask for, so the query has no params: one stable key, never enabled.
 */
export function siteTimelineQueryParams(
    scope: SiteTimelineScope | null
): LocationFishGroupsController_timelineQueryParams | undefined {
    return scope === null ? undefined : { stockingCycleId: String(scope) };
}

/**
 * Whether a cached timeline query is for a resolved scope. The unresolved entry keeps its
 * queryFn, and once its observer has moved on to a real scope nothing marks it disabled any
 * more, so an invalidation with `refetchType: 'all'` would fetch it without a scope.
 */
export function isResolvedSiteTimelineQuery(query: Query): boolean {
    const params: unknown = query.queryKey[3];
    if (!params || typeof params !== 'object' || !('stockingCycleId' in params)) return false;
    const { stockingCycleId } = params;
    return typeof stockingCycleId === 'string' && RESOLVED_SCOPE.test(stockingCycleId);
}
